import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router' // 注册路由


import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
AOS.init();



const app = createApp(App);
app.use(router);
app.mount('#app');